import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { setConfirmAgreement } from '../../store/merchnts/actions/self-onboarding';
import { LinkComponent } from '../LinkComponent';
import DOMPurify from 'dompurify';

const makeLinksHttps = (html: string): string => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const links = doc.querySelectorAll('a');

  links.forEach(link => {
    console.log('link---', link);
    const href = link.getAttribute('href');
    if (href && !href.startsWith('http://') && !href.startsWith('https://')) {
      link.setAttribute('href', `https://${href}`);
    }
    link.setAttribute('target', '_blank');
  });

  return doc.body.innerHTML;
};

const isValidHTML = (html: string): boolean => {
  try {
    if (!html) {
      return false;
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
  } catch (e) {
    return false;
  }
};

export const ApplicationViewAgreement: FC = () => {
  const { t } = useTranslation();
  const { merchantState: { isConfirmAgreement, applicationViewData }, dispatch } = useMerchants();

  const handleCheck = (): void => {
    setConfirmAgreement(dispatch, isConfirmAgreement);
  };

  const isTermsAndConditionsUrlValid = isValidHTML(applicationViewData?.termsAndConditions);
  const sanitizedTermsAndConditions = isTermsAndConditionsUrlValid
      ? DOMPurify.sanitize(makeLinksHttps(applicationViewData.termsAndConditions), {
        ADD_ATTR: ['target'], // Allow the 'target' attribute
      })
      : null;

  if (isTermsAndConditionsUrlValid && sanitizedTermsAndConditions) {
    return (
        <div className="card mb-5">
          <div className="card-body">
            <div className="">
                <div dangerouslySetInnerHTML={{ __html: sanitizedTermsAndConditions }} />
              <div className="form-check">
                <input
                    type="checkbox"
                    className="form-check-input"
                    onChange={handleCheck}
                    checked={isConfirmAgreement}
                />
                {
                  applicationViewData.consentLabel ? (
                      <span>{applicationViewData.consentLabel}</span>
                  ) : (
                      <span>I acknowledge the Financial Disclosure</span>
                  )
                }
              </div>
            </div>
          </div>
        </div>
    );
  }

  return (
      <div className="card mb-5">
        <div className="card-body">
          <div className="d-flex align-items-start">
            <div className="form-check">
              <input
                  type="checkbox"
                  className="form-check-input"
                  onChange={handleCheck}
                  checked={isConfirmAgreement}
              />
            </div>
            <div className="ms-5">
              <span className="fs-6">
                {t('CONFIRM_APP.AGREEMENT_TEXT')}
              </span>

              <LinkComponent
                  text={t('CONFIRM_APP.MERCHANT_AGREEMENT')}
                  link={applicationViewData?.merchantTermsAndConditionsUrl}
                  additionalClass="fs-6 mx-1"
              />

              <span className="fs-6">{t('CONFIRM_APP.AND')}</span>

              <LinkComponent
                  text={t('CONFIRM_APP.TERMS_AND_CONDITIONS')}
                  link={applicationViewData?.termsAndConditionsUrl}
                  additionalClass="mx-1"
              />

              <span className="fs-6">
                and I confirm that the information above is accurate.
              </span>
            </div>
          </div>
        </div>
      </div>
  );
};
